// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".searchSnippet[data-v-6731a078] {\n  margin: 5px 20px;\n}\n.capitalize[data-v-6731a078] {\n  text-transform: capitalize;\n}\n[data-v-6731a078] tbody tr.v-data-table__expanded__content {\n  background: #efefef;\n  box-shadow: none !important;\n}", ""]);
// Exports
module.exports = exports;
